import React from 'react'
import Hero from './Hero'
import aboutUs from '../Assets/Images/about-us.avif'
import CountUp from "react-countup";
import { Link } from 'react-router-dom';
import Projects from './Projects';
import DesignServicesIcon from '@mui/icons-material/DesignServices';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import InterestsIcon from '@mui/icons-material/Interests';
import BrushIcon from '@mui/icons-material/Brush';
import AnimationIcon from '@mui/icons-material/Animation';
import CampaignIcon from '@mui/icons-material/Campaign';
import GreenLeaf from '../Assets/Images/Clients/green-leaf.avif'
import BBQNights from '../Assets/Images/Clients/bbq-nights.avif'
import DoodhNagar from '../Assets/Images/Clients/doodh-nagar.avif'
import DesignFresh from '../Assets/Images/Clients/design-fresh.avif'
import GSS from '../Assets/Images/Clients/gss.avif'
import Jaffar from '../Assets/Images/Clients/jaffar.avif'
import taoniRajput from '../Assets/Images/Clients/taoni-rajput.avif'
import Testimonials from './Testimonials';
import RocketIcon from '@mui/icons-material/Rocket';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import HailIcon from '@mui/icons-material/Hail';



function Home() {
  return (
    <div>
      <Hero />


      <section className="about-us">
        <div className="container pt-5">
          <div className="row d-flex justify-cotent-center align-items-center ">
            
            <div className="col-md-7" data-aos="fade-up" data-aos-duration="2000">
              <div className="section-header mb-4">
                <h6>Who We Are</h6>
                <h2>Crafting Visual Excellence With Precision And Passion</h2>
              </div>
              <p className='mb-4'>Farooq Graphics is not just a graphics designing company; we are storytellers, visual magicians, and creative strategists. Established with a passion for transforming ideas into captivating visuals, our team of talented designers is dedicated to bringing your vision to life. With a commitment to excellence and a keen eye for detail, we strive to redefine the boundaries of graphic design, ensuring that each project we undertake is a masterpiece in its own right.</p>
              <div className="row d-flex justify-content-center align-items-center stats mb-4">
                <div className="col-md-4 col-4">
                <CountUp
                    start={0}
                    end={150}
                    duration={3}
                    className='counter stat-1'
                />
                <h3>Expert Designers</h3>
                  
                </div>
                <div className="col-md-4 col-4">
                <CountUp
                    start={0}
                    end={500}
                    duration={3}
                    className='counter stat-2'
                />
                <h3>Satisfied Clients</h3>
                </div>
                <div className="col-md-4 col-4 extra" style={{marginRight: '-28px', borderRight: 'none'}}>
                <CountUp
                    start={0}
                    end={100}
                    duration={3}
                    className='counter stat-3'
                />
                <h3>Client Satisfaction</h3>
                </div>
              </div>
            </div>
            
            <div className="col-md-5 order-md-2" data-aos="fade-down" data-aos-duration="2000">
              <div className="img-overlay">
              <img src={aboutUs} alt="graphic-designing-company" className="img-fluid" />
              <div className="overlay"></div>
              </div>
            </div>
            
          </div>
          <div className='d-flex button-box mt-3'>
            <Link to='/about-company' className='me-3'><button className="first-button ">Learn More <span>&rarr;</span></button></Link>
            <Link to='/contact'><button className="second-button">Connect Now</button></Link>
          </div>
        </div>
      </section>


      <Projects />


      <section className="services pt-5 px-4 mb-5">
        <div className="container-fluid">
          <div className="row justify-content-center align-items-center">
            <div className="col-md-2 col-6" data-aos="fade-right" data-aos-duration="2000">
              <div className="card service-card">
                <div className="card-content">
                  <DesignServicesIcon className='mui-icon'/>
                </div>
                <Link to="/our-services"><h4>Designing</h4></Link>
              </div>
            </div>

            <div className="col-md-2 col-6" data-aos="fade-right" data-aos-duration="2000">
              <div className="card service-card">
                <div className="card-content">
                  <ShoppingBagIcon className='mui-icon'/>
                </div>
                <Link to="/our-services"><h4>Print & Packaging</h4></Link>
              </div>
            </div>

            <div className="col-md-2 col-6" data-aos="fade-right" data-aos-duration="2000">
              <div className="card service-card">
                <div className="card-content">
                  <InterestsIcon className='mui-icon'/>
                </div>
                <Link to="/our-services"><h4>Social Media Graphics</h4></Link>
              </div>
            </div>

            <div className="col-md-2 col-6" data-aos="fade-right" data-aos-duration="2000">
              <div className="card service-card">
                <div className="card-content">
                  <BrushIcon className='mui-icon'/>
                </div>
                <Link to="/our-services"><h4>Illustration Services</h4></Link>
              </div>
            </div>

            <div className="col-md-2 col-6" data-aos="fade-right" data-aos-duration="2000">
              <div className="card service-card">
                <div className="card-content">
                  <AnimationIcon className='mui-icon'/>
                </div>
                <Link to="/our-services"><h4>Motion Graphics & Animations</h4></Link>
              </div>
            </div>

            <div className="col-md-2 col-6" data-aos="fade-right" data-aos-duration="2000">
              <div className="card service-card">
                <div className="card-content">
                  <CampaignIcon className='mui-icon'/>
                </div>
                <Link to="/our-services"><h4>Brand Identity</h4></Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="why-choose-us pt-5 pb-5">
        <div className="container">
          <div className="row">
            <div className="col-md-5" data-aos="fade-right" data-aos-duration="2000" data-aos-delay="200">
              <div className="section-header">
                <h6>Unleash Your Imagination</h6>
                <h2>Unlock Your Brand's Potential With Farooq Graphics</h2>
              </div>
              <p>At Farooq Graphics, we transcend traditional graphic design boundaries. Our approach is rooted in innovation, empowering your ideas to reach new heights. We believe in turning creative visions into visually stunning realities that captivate, communicate, and inspire.</p>
              <div className="list-points">
                <ul>
                <li><i class="fa-solid fa-circle-check"></i>&nbsp;Elevate your brand with innovative designs that leave a lasting impression.</li>
                <li> <i class="fa-solid fa-circle-check"></i>&nbsp; Align visual elements with goals for purposeful and successful designs.</li>
                <li><i class="fa-solid fa-circle-check"></i>&nbsp;Collaborate closely for personalized, unique design solutions.</li>
                <li><i class="fa-solid fa-circle-check"></i>&nbsp; Rely on prompt and efficient delivery without compromising quality.</li>
                </ul>
              </div>
              <div className='mt-4'>
              <Link to="/contact"><button className="first-button">Wokr With Us <span>&rarr;</span></button></Link>
              </div>
            </div>

            <div className="col-md-7">
              <div className="row">
                <div className="col-md-6" data-aos="fade-down" data-aos-duration="2000" data-aos-delay="200"> 
                  <div className="card why-choose-card mt-5">
                    <div className="wc-content">
                    <BrushIcon className='mui-icon' style={{fontSize: '34px'}}/>
                    <h5>Bespoke Design Solutions</h5>
                    <p>Tailored designs that make your brand stand out and resonate with your audience.</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 mb-4" data-aos="fade-down" data-aos-duration="2000" data-aos-delay="200">
                  <div className="card why-choose-card second">
                    <div className="wc-content">
                    <RocketIcon className='mui-icon' style={{fontSize: '34px'}}/>
                    <h5>Cutting-Edge Technology</h5>
                    <p>Utilize the latest tools and technologies for designs that are visually stunning and technologically advanced.</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="200">
                  <div className="card why-choose-card mt-5 third">
                    <div className="wc-content">
                    <AccountTreeIcon className='mui-icon' style={{fontSize: '34px'}}/>
                    <h5>Collaborative Design Process</h5>
                    <p>Involve yourself at every step, ensuring the final design is a true reflection of your vision and goals.</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="200">
                  <div className="card why-choose-card">
                    <div className="wc-content">
                    <HailIcon className='mui-icon' style={{fontSize: '34px'}}/>
                    <h5>Dedicated Design Experts</h5>
                    <p>Benefit from our team of passionate design experts committed to delivering top-notch designs that make a lasting impact.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section className="clients-section pt-5 pb-4">
        <div className="container">
          <div className="row d-flex justify-content-center align-items-center">
            <div className="col-md-4 mb-3" data-aos="fade-right" data-aos-duration="2000" data-aos-delay="200">
              <div className="section-header">
                <h6>Trusted Partnerships</h6>
                <h2>Explore Our Collaborations With Exceptional Brands</h2>
              </div>
              <p>Dive into a visual journey showcasing our collaborations with exceptional brands. Trusted partnerships that speak volumes through design.</p>
              <Link to="/our-clients"><button className="first-button">View Clients <span>&rarr;</span></button></Link>
            </div>

            <div className="col-md-8" data-aos="fade-left" data-aos-duration="2000" data-aos-delay="200">
              <div className="row px-4 text-center d-flex justify-content-center align-items-center">
            <div className="col-md-3 client-logo">
              <img src={GreenLeaf} alt="green-leaf-client" className="img-fluid" />
            </div>
            <div className="col-md-3 client-logo">
              <img src={BBQNights} alt="bbq-nights-client" className="img-fluid" />
            </div>
            <div className="col-md-3 client-logo">
              <img src={DoodhNagar} alt="doodh-nagar-client" className="img-fluid" />
            </div>
            <div className="col-md-3 client-logo">
              <img src={DesignFresh} alt="design-fresh-client" className="img-fluid" />
            </div>
              </div>

              <div className="row px-4 text-center d-flex justify-content-center align-items-center">
                <div className="col-md-3 client-logo">
                  <img src={GSS} alt="gss-client" className="img-fluid" />
                </div>
                <div className="col-md-3 client-logo">
                  <img src={Jaffar} alt="jaffar-client" className="img-fluid" />
                </div>
                <div className="col-md-3 client-logo">
                  <img src={taoniRajput} alt="taoni-rajput-client" className="img-fluid" />
                </div>
                <div className="col-md-3 client-logo">
                  <img src={DesignFresh} alt="design-fresh-client" className="img-fluid" />
                </div>
              </div>
            </div>
          </div>
        </div>
    </section>


   <section className='pb-4' style={{backgroundColor: '#f3f6fb'}} data-aos="fade-up" data-aos-duration="2000" data-aos-delay="200">
    <Testimonials />
    </section>
    </div>
  )
}

export default Home
